"use client";

import { useClickOutside } from "@repo/lib/hooks/common";
import { Link, usePathname } from "@/i18n/routing";
import { LANGUAGES } from "@/lib/constants/common";
import { IconCheckBlack, IconGlobe, IconSortByMobile } from "@repo/assets/images";
import { BottomSheet } from "@repo/ui";
import cx from "classnames";
import { useLocale, useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { useCallback, useRef, useState } from "react";
const LanguageDropdown = () => {
  const t = useTranslations("Common");
  const [isOpen, setIsOpen] = useState(false);
  const [isUserDropdownBottomSheetOpen, setIsUserDropdownBottomSheetOpen] = useState(false);
  const dropdownRef = useRef();
  const locale = useLocale();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  // Construct the href with the current pathname and search params or just the pathname if no search params exist
  const href = search ? `${pathname}?${search}` : pathname;
  const currentLang = LANGUAGES.find(l => l.code === locale) || LANGUAGES[0];
  const DropdownContent = ({
    onClick
  }) => {
    return <div className={cx("bg-languageSelection-bg end-0 z-50 -mx-4 mt-2 origin-top-right overflow-hidden md:absolute md:mx-0 md:w-52 md:shadow-lg md:ring-1 md:ring-black md:ring-opacity-5 rtl:md:w-52", {
      "hidden md:block": isOpen
    })} data-sentry-component="DropdownContent" data-sentry-source-file="LanguageDropdown.jsx">
        <>
          <div className="divide-languageSelection-border border-languageSelection-border divide-y border-b md:border-b-0">
            {LANGUAGES.map(lang => <Link key={lang.code} href={href} locale={lang.code} className={cx("hover:bg-languageSelection-active-bg text-languageSelection-text flex items-center px-4 py-2 text-sm font-medium", {
            "bg-languageSelection-active-bg": lang.code === locale
          })} onClick={onClick}>
                <span className="me-2">{lang.icon}</span>
                {lang.label} ({lang.short})
                {lang.code === locale && <IconCheckBlack className="text-languageSelection-icon ms-auto fill-current" />}
              </Link>)}
          </div>
        </>
      </div>;
  };
  const handleDropdown = useCallback(() => setIsOpen(prev => !prev), []);
  const handleCloseDropdown = useCallback(() => setIsOpen(false), []);
  const handleUserDropdownBottomSheet = () => {
    setIsUserDropdownBottomSheetOpen(!isUserDropdownBottomSheetOpen);
  };
  useClickOutside(dropdownRef, handleCloseDropdown);
  return <div className="relative inline-block px-2 md:ps-2" data-sentry-component="LanguageDropdown" data-sentry-source-file="LanguageDropdown.jsx">
      <div ref={dropdownRef}>
        <button type="button" className="rtl:font-body bg-header-languageSelectionBg border-header-icon text-languageSelection-buttonText hidden w-[88px] items-center justify-center space-x-2 rounded-full border-2 py-1 text-base font-medium focus:outline-none md:flex rtl:space-x-reverse" onClick={handleDropdown} aria-label="Select Language">
          <span>
            <IconGlobe className="text-languageSelection-buttonText fill-current" data-sentry-element="IconGlobe" data-sentry-source-file="LanguageDropdown.jsx" />
          </span>
          <span>{currentLang.short}</span>
          <IconSortByMobile className={cx("text-languageSelection-buttonText ms-auto transform fill-current transition-transform duration-300", {
          "rotate-180": !isOpen
        })} data-sentry-element="IconSortByMobile" data-sentry-source-file="LanguageDropdown.jsx" />
        </button>
        <button type="button" className="text-languageSelection-buttonText inline-flex w-full items-center justify-center space-x-2 py-2 text-sm font-medium focus:outline-none md:hidden rtl:space-x-reverse" onClick={handleUserDropdownBottomSheet} aria-label="Select Language">
          <span>
            <IconGlobe className="text-languageSelection-buttonText fill-current" data-sentry-element="IconGlobe" data-sentry-source-file="LanguageDropdown.jsx" />
          </span>
        </button>
        <BottomSheet isOpen={isUserDropdownBottomSheetOpen} onClose={handleUserDropdownBottomSheet} variant="auto" data-sentry-element="BottomSheet" data-sentry-source-file="LanguageDropdown.jsx">
          <DropdownContent onClick={() => {
          setIsOpen(false);
          handleUserDropdownBottomSheet();
        }} data-sentry-element="DropdownContent" data-sentry-source-file="LanguageDropdown.jsx" />
        </BottomSheet>
        {isOpen && <DropdownContent onClick={() => {
        setIsOpen(false);
      }} />}
      </div>
    </div>;
};
export default LanguageDropdown;